export default {
	vw(value, base = 1366) {
		return value / base * innerWidth;
	},

	vh(value, base = 800) {
		return value / base * innerHeight;
	},

	vmin(value, base = 375) {
		return value / base * Math.min(innerWidth, innerHeight);
	},

	xl(value, base = 2000 / 1366) {
		return value * base;
	},

	getOffset(value) {
		let offset = this.vw(value);

		if (innerWidth >= 2000) {
			offset = this.xl(value);
		} else if (innerWidth <= 1024) {
			offset = this.vmin(value);
		}

		return offset;
	},

	checkItemPos(item, offset = 0) {
		const $item = $(item);

		const currOffset = this.getOffset(offset);

		const scrollPos = pageYOffset + innerHeight;

		const $itemBottomPos = $item.offset().top;

		return scrollPos - currOffset >= $itemBottomPos;
	},
};
